<script lang="ts">
import { computed, defineComponent } from "vue";
import VorschadenFHVHV from "@/components/vorschaeden/VorschadenFHVHV.vue";
import TitelZelle from "@/components/grid/TitelZelle.vue";
import Zelle from "@/components/grid/Zelle.vue";
import Zeile from "@/components/grid/Zeile.vue";
import ValidierungsFehler from "@/components/ValidierungsFehler.vue";
import { useFormStore } from "@/businesslogic/stores/formStore";

export default defineComponent({
  name: "VorschaedenFHVHV",
  components: {
    TitelZelle,
    Zelle,
    Zeile,
    ValidierungsFehler,
    VorschadenFHVHV,
  },
  props: {
    fehler: Object,
    zeigeSchadenart: {
      type: Boolean,
      default: true,
    },
    schadenartDefault: String,
    produkt: String,
  },
  setup(props) {
    const piniaStore = useFormStore();

    const vorschadenFrage = computed(() => {
      return (
        "Anzahl Vorschäden " +
        props.produkt +
        " in den letzten 5 Jahren? (bei Elementarschäden in den letzten 10 Jahren)"
      );
    });

    return {
      props,
      piniaStore,
      vorschadenFrage,
    };
  },
});
</script>

<template>
  <zeile class="u-mar-t-1">
    <titel-zelle>
      {{ vorschadenFrage }}
    </titel-zelle>
    <zelle :breite="3">
      <select
        v-model.number="piniaStore.state.ferienhaus.vhv.tarifinformationen.vorschaedenAnzahl"
        id="vhvvorschaedenAnzahl"
        name="vhvvorschaedenAnzahl"
        data-cy="vhvtariffNumberOfPredamages"
        class="c-form-control-select"
        required
        aria-required="true"
        aria-label="Anzahl der Vorschäden"
        data-fehlermeldung="Bitte wählen Sie die Anzahl der Vorschäden aus."
      >
        <option v-if="piniaStore.state.ferienhaus.vhv.tarifinformationen.vorschaedenAnzahl === -1" value="-1">
          Bitte wählen Sie
        </option>
        <option value="0">0</option>
        <option value="1">1</option>
        <option value="2">2</option>
        <option value="3">3</option>
        <option value="4">4</option>
        <option value="5">5 oder mehr</option>
      </select>
      <validierungs-fehler :fehler-text="fehler.vhvvorschaedenAnzahl" :reduzierter-abstand="true" />
    </zelle>
  </zeile>

  <div v-if="piniaStore.state.ferienhaus.vhv.tarifinformationen.vorschaedenAnzahl >= 0">
    <vorschadenFHVHV
      v-for="vorschadenId in piniaStore.state.ferienhaus.vhv.tarifinformationen.vorschaedenAnzahl"
      :key="vorschadenId"
      :vorschadenId="vorschadenId"
      :fehler="fehler"
      v-bind:zeige-schadenart="zeigeSchadenart"
      sparte="vhv"
    ></vorschadenFHVHV>
  </div>
</template>
